import { render, staticRenderFns } from "./RateNew.vue?vue&type=template&id=e75ce3e4&"
import script from "./RateNew.vue?vue&type=script&lang=js&"
export * from "./RateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e75ce3e4', component.options)
    } else {
      api.reload('e75ce3e4', component.options)
    }
    module.hot.accept("./RateNew.vue?vue&type=template&id=e75ce3e4&", function () {
      api.rerender('e75ce3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/RateNew.vue"
export default component.exports